import type {Holidays} from 'src/types/scheduler/holidays';
import type {SchedulerHolidayActions} from 'src/action-creators/scheduler/holidays';

import {
  SET_HOLIDAYS,
  ADD_HOLIDAY,
  EDIT_HOLIDAY,
  REMOVE_HOLIDAY,
} from 'src/action-creators/scheduler/holidays';


export default (
  state: Holidays = [],
  action: SchedulerHolidayActions,
): Holidays => {
  switch (action.type) {
    case SET_HOLIDAYS:
      return action.payload;
    case ADD_HOLIDAY:
      return [...state, action.payload];
    case EDIT_HOLIDAY:
      return state.map((holiday) =>
        holiday.id === action.payload.id ? action.payload : holiday,
      );
    case REMOVE_HOLIDAY:
      return state.filter((holiday) => holiday.id !== action.payload);
    default:
      return state;
  }
};
